import React from 'react';
import { useSelector } from 'react-redux';

import css from '../../css/group/header.module.scss';
import { ReactComponent as Human } from '../../img/group/header/human.svg';
import { selectChatGroup } from '../../slice/chatGroupSlice';
import { selectVoiceCall } from '../../slice/voiceCallSlice';
import { MyPopup } from '../common/myPopup';

export const Header: React.FC<{ showMembers: boolean }> = (props) => {
    const { selectedChatGroup: group } = useSelector(selectChatGroup);
    const { room } = useSelector(selectVoiceCall);
    const popupContent = (
        <ul className={css.popup}>
            {group?.members.map((member, idx) => {
                return (
                    <li key={idx}>
                        <img src={member.icon} alt="" />
                        {member.name}
                    </li>
                );
            })}
        </ul>
    );

    let name = group ? group.name : '';
    if (room !== undefined) {
        name += ' | ' + room.name;
    }

    return (
        <div className={css.header}>
            <img src={group?.icon} alt="" />
            <h1>{name}</h1>
            {props.showMembers && (
                <>
                    <MyPopup
                        trigger={<Human height={24} width={24} role="img" aria-label="メンバー一覧" />}
                        title="メンバー一覧"
                        content={popupContent}
                    />
                    <span>{group?.members.length}</span>
                </>
            )}
        </div>
    );
};
